export const sessionErrorAction = message => ({
  type: "USER_SESSION_ERROR_MESSAGE",
  payload: message
});

export const setErrorMessageAction = message => ({
  type: "API_CALL_ERROR_MESSAGE",
  payload: message
});
